import { Skeleton as SkeletonPrimitive } from '@/components/ui/skeleton';

export type SkeletonProps = React.ComponentProps<'div'>;

/**
 * Skeleton with aria-hidden for accessibility.
 * Wraps the ui/ primitive to add the aria attribute.
 */
function Skeleton(props: SkeletonProps) {
  return (
    <SkeletonPrimitive data-slot="skeleton" aria-hidden="true" {...props} />
  );
}

Skeleton.displayName = 'Skeleton';

export { Skeleton };
